import {
  BackdropUnstyled,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import React, { useState, useEffect } from "react";
import styles from "./GeneralInputField.module.css";

export const GeneralSelectFieldForHeader = (props) => {
  const { label, data, setData, dataKey, submitted, itemVal, place, disabled } =
    props;

  const [value, setValue] = useState(data);
  // console.log("Data in General Select Field on update",place);

  var dropItems = props.items;

  const handleChange = (event) => {
    setData(event.target.value);
    setValue(event.target.value);
  };

  return (
    <FormControl
      sx={{
        // width: `${props.width ? props.width : "100%"}`,
        border: "0px",
      }}
    >
      {/* first drop down */}

      <Select
        labelId="demo-simple-select-label"
        // id="demo-simple-select"
        id={styles.selectField}
        value={value}
        disableUnderline
        // BackdropUnstyled
        sx={{
          backgroundColor: "none",
        }}
        variant="standard"
        onChange={handleChange}
        // IconComponent={() => <ArrowDropDownIcon fontSize="large"/>}
        // style={{
        //   border: "0px",
        //   outline: "0px",
        //   fontSize: "1.5rem",
        //   fontFamily: "Mulish",
        //   fontStyle: "normal",
        //   fontWeight: "bold",
        // }}
      >
        {dropItems.map((e, i) => {
          return (
            <MenuItem key={i} value={e} id={styles.selectOption}>
              {e}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};
